import { GridRenderEditCellParams } from '@mui/x-data-grid';
import { TextField } from '@mui/material';
import { IPets } from 'app/models/Placement/PlacementMods';
import React, { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { selectEditPreferencePetsRows } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { findIndex, findRow } from '../AdultGridComponents/AdultNameCell';
import { getDisplayValue } from '../utils';

interface GridCellProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export const PetBreedCell = (cellParams: GridRenderEditCellParams) => {
  return (
    <>
      <PetBreed cellParams={cellParams} />
    </>
  );
};

const PetBreed = React.memo(function PetBreed(cellParams: GridCellProps) {
  const { control } = useFormContext();
  const dispatch = useDispatch();
  const editPreferencePetsRequests = useSelector(selectEditPreferencePetsRows);
  const RowId = cellParams?.cellParams?.id;
  const rowData = getDisplayValue(RowId, editPreferencePetsRequests);
  const breed = rowData?.breed;
  const [petBreed, setPetBreed] = useState(breed === '--' ? null : breed);

  const setBreedForPetGridEdit = data => {
    let newRows = editPreferencePetsRequests.slice(0);
    let petsGridEditRow = findRow(editPreferencePetsRequests, RowId);

    let updatedBreed = {} as IPets;
    updatedBreed = {
      ...petsGridEditRow,
      breed: data.trim() ? data : '',
    };
    let editBreedIndex = findIndex(editPreferencePetsRequests, RowId);
    newRows[editBreedIndex] = updatedBreed;
    dispatch(placementModsAction.setEditPetsRows(newRows));
  };

  return (
    <>
      <Controller
        name={`petsGrid${RowId}.breed`}
        control={control}
        render={({ field: { onChange, onBlur, value, ...rest } }) => (
          <TextField
            required={true}
            variant="outlined"
            size={'small'}
            sx={{
              width: '150px',
            }}
            value={petBreed}
            inputProps={{ maxLength: 255 }}
            onBlur={e => {
              setBreedForPetGridEdit(e.target.value);
              onChange(e.target.value);
            }}
            onChange={e => {
              if (e.target.value) {
                setPetBreed(e.target.value);
                onChange(e.target.value);
              } else {
                setPetBreed('');
              }
            }}
            {...rest}
          />
        )}
      />
    </>
  );
});
